jQuery("body").on("click", "#show_bids, #place_my_bid", function(e) {
  document.body.classList.add("bids-open", "noselect");
});

jQuery("body").on("click", ".pa-modal-container", function(e) {
  if(e.target.classList.contains('pa-modal-container')
      || e.target.classList.contains('pa-icon-close')
      || e.target.classList.contains('pa-button-close')
      || e.target.parentElement.classList.contains('pa-icon-close')
    ) {
    setTimeout(() => {
      document.body.classList.remove("bids-open");
    }, 200);
  }
});